import { SCMTrainingOptionsMainProps, TrainingOption } from './Types';
import TrainingOptions from './TrainingOptions';
import { useTheme } from '@emotion/react';
import {
  headingColor,
  normalizeHeadingLevel,
} from '../../../services/styleUtils/headingStyleUtils';
import { getContentStyle } from '../../../services/styleUtils/contentStyleUtils';
import { themeColor } from '../../../services/styleUtils/colorUtils';

const OnDemandTrainingsMain = ({ fields }: SCMTrainingOptionsMainProps) => {
  const theme = useTheme();

  const transformedOptions: TrainingOption[] = fields.trainingOptions
    ? fields.trainingOptions.map((option) => ({
        iconUrl: option.fields.iconImage.url,
        text: option.fields.text,
      }))
    : [];

  const backgroundColor = fields.backgroundStyle?.fields?.color
    ? themeColor(theme, fields.backgroundStyle?.fields?.color)
    : null;

  const normalizedTitleLevel = normalizeHeadingLevel(
    fields.titleStyle?.fields?.level,
  );
  const titleTextColor = fields.titleStyle?.fields?.color
    ? headingColor(theme, fields.titleStyle?.fields?.color)
    : '#FFF';
  const titleAlignment = fields.titleStyle?.fields?.alignment || 'center';

  const subTitleStyle = fields.subTitleStyle?.fields
    ? getContentStyle(theme, fields.subTitleStyle?.fields)
    : null;

  const trainingOptionsProps = {
    title: fields.title || '',
    subtitle: fields?.subTitle || null,
    options: transformedOptions,
    backgroundStyle:
      backgroundColor || fields?.backgroundImage?.url
        ? {
            color: backgroundColor,
            image: fields?.backgroundImage?.url || null,
            gradientOverlay: fields?.useGradient?.toLowerCase() === 'true',
          }
        : null,
    titleStyle: {
      level: normalizedTitleLevel,
      color: titleTextColor,
      alignment: titleAlignment,
    },
    subTitleStyle: subTitleStyle
      ? {
          color: subTitleStyle?.textColor || '#fff',
          textSize: subTitleStyle?.fontSize || '16px',
          alignment: subTitleStyle?.alignment || 'center',
          lineHeight: subTitleStyle?.lineHeight || '1.5',
        }
      : null,
    optionIconColor: fields?.iconColor?.fields?.color
      ? themeColor(theme, fields?.iconColor?.fields?.color)
      : '#fff',
    optionTextColor: fields?.iconTextColor?.fields?.color
      ? themeColor(theme, fields?.iconTextColor?.fields?.color)
      : '#fff',
    optionAlignment: fields?.alignment,
    optionMobileAlignment: fields?.mobileAlignment,
  };

  return <TrainingOptions {...trainingOptionsProps} />;
};

export default OnDemandTrainingsMain;
